let Constants = {
	PROMO_CODE: "648",
	CH_PROMO: "CH_648_MLB_WEB_PANI22_SFB_NAV_20220214_20220515",
	API_PROMOCODE: "pani-2022"
}
export default Constants;
